export const SPOTIFY_PLAYER_SIZE = {
  XSMALL: "XSMALL",
  SMALL: "SMALL",
  LARGE: "LARGE",
};

export const SIZE_TO_HEIGHT_MAP = {
  [SPOTIFY_PLAYER_SIZE.XSMALL]: 64,
  [SPOTIFY_PLAYER_SIZE.SMALL]: 84,
  [SPOTIFY_PLAYER_SIZE.LARGE]: 152,
};
